export default __webpack_public_path__ + "5ed4348ea54e90e37342d79a4292be9d.jpg";